import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { DropdownWithLabel } from '@blueprint/dropdown';
import { MultiColumnDropdownWithLabel } from '@blueprint/multicolumn-dropdown';

import { getRems } from '../Layout/Layout.styles';

export const StyledDropdown = styled(DropdownWithLabel)(
    ({ theme: { spacing } }) => css`
        margin: ${spacing['8px']};
    `
);

export const StyledDropdownToRentPrice = styled(DropdownWithLabel)(
    () => css`
        min-width: ${getRems(240)};
    `
);

export const StyledPriceFrequencyDropdown = styled(DropdownWithLabel)(
    ({ theme: { spacing } }) => css`
        margin-bottom: ${spacing['16px']};
    `
);

export const PropertyTypeRadioButtonWrapper = styled.div(
    () => css`
        display: flex;
        flex-wrap: wrap;
    `
);

export const DropdownWrapper = styled.div(
    () => css`
        display: flex;
    `
);

export const AllDropdownsWrapper = styled.div(
    () => css`
        min-width: 28.525rem;
    `
);

export const LeftWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        padding-right: ${spacing['8px']};
        width: 50%;
    `
);

export const RightWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        padding-left: ${spacing['8px']};
        width: 50%;
    `
);

export const MultiColumnDropdownWithLabelTravelTime = styled(
    MultiColumnDropdownWithLabel
)(
    () => css`
        border-left-width: 1px;
    `
);
